import { render, staticRenderFns } from "./BlogList.vue?vue&type=template&id=1aaf7595&"
import script from "./BlogList.vue?vue&type=script&lang=ts&"
export * from "./BlogList.vue?vue&type=script&lang=ts&"
import style0 from "./BlogList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports